module.exports = __webpack_public_path__ + "static/media/faq-infographic-picture.b0acbeda.png";